<template>
	<div class="common-alarm-page">
		<gc-header header-data="dedicatedAlarm" />
		<div class="page-content">
			<ConfigList
				v-model="selectedItem"
				:selectedItem="selectedItem"
				:list="configList"
				class="content-left"
				@click="handleClick"
			/>
			<ConfigTable
				:id="selectedItem.value"
				:name="selectedItem.label"
				:show-comparison-name="selectedItem.showComparisonName"
				class="content-right"
				@update="handleUpdate"
			/>
		</div>
	</div>
</template>

<script>
import { apiGetCommonAlarmConfig } from '@/apis/waterAlarmConfig.api'
import ConfigTable from './table-area/index.vue'
import ConfigList from '../components/ConfigList.vue'

export default {
	name: 'DedicatedAlarm',
	components: {
		ConfigList,
		ConfigTable,
	},
	provide() {
		return {
			getComparison: () => this.selectedItem,
		}
	},
	data() {
		return {
			selectedItem: {},
			configList: [],
		}
	},
	activated() {
		this.initConfigList()
	},
	methods: {
		handleClick(item) {
			this.selectedItem = item
		},
		handleUpdate() {
			this.initConfigList()
		},
		async initConfigList() {
			const res = await this.getConfigList()
			const list = this.dealRes(res)
			this.configList = list
			this.handleClick(this.selectedItem.value ? this.selectedItem : list[0])
		},
		dealRes(list) {
			return list.map(item => ({
				label: item.eventName,
				value: item.eventId,
				number: item.total,
				showComparisonName: !!item.comparisonName,
				comparisonName: item.comparisonName,
				comparisonUnit: item.comparisonUnit,
				eventExpression: JSON.parse(item.eventExpression),
			}))
		},
		getConfigList() {
			return apiGetCommonAlarmConfig({ alarmSource: '3' })
				.then(res => res)
				.catch(() => [])
		},
	},
}
</script>

<style scoped lang="scss">
.common-alarm-page {
	display: flex;
	flex-direction: column;
	height: 100%;
}

.page-content {
	flex: 1;
	display: flex;
	overflow: hidden;
}
.content-left {
	width: 360px;
	height: 100%;
	padding: 25px;
	border-right: 1px dashed #f1f1f1;
}

.content-right {
	flex: 1;
	min-width: 0;
}
</style>
